


/*****************************************************
			GENERAL FUNCTIONS THROUGH SITE
/*****************************************************/

	function changeOpacity(){
		let body_page = document.querySelector('body');
		body_page.classList.add('visible');
	}

	function goBack(){
		window.history.back();
	}

	function cropText(title){
		let words = title.innerHTML.split(" ");
		let full_string = '';
		words.forEach((elem)=>{
			full_string += '<span class="clear-span">'+elem+'</span>';
		});
		title.classList.add('animate-fade','title-tagged');
		title.innerHTML = full_string;
	}

	//Polyfill to use foreach in IE
	if (window.NodeList && !NodeList.prototype.forEach) {
	    NodeList.prototype.forEach = Array.prototype.forEach;
	}
	
/********************************************************************************
						END OF CHANGE OPACITY TO THE SITE
***********************************************************************************/
// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}
	
	//if there is alert
	setTimeout(() => {
		if(document.getElementsByClassName('topalert').length > 0){
			document.getElementsByTagName('body')[0].classList.add('withalert')
		}
	}, 500);

	//home video
	if(document.getElementById('hero-video')){
		let homevideo = document.getElementById('hero-video');
		
		homevideo.addEventListener('loadedmetadata', function(event){
			
				setTimeout(function(){
					homevideo.play();
				},1500);
			
		})
		
	}


	/*****************************************************
	OBSERVER TO CHANGE THE HEADER
	/*****************************************************/

	let observer_item = document.querySelector(".header-circa");
	let observable = document.getElementById('js-circa-scroll');

	if (observer_item && observable){
		let options = {
			root: null, // relative to document viewport 
			rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: 0 // visible amount of item shown in relation to root
		};

		// console.log(observer_item);

		function handler(entries, observer) {
			//console.log('🍺');
			let entry;
			entries.forEach(function(entry){
					if (entry.isIntersecting) {
						observer_item.classList.remove("scroll");
					} else {
						observer_item.classList.add("scroll");
					}
				});
		}

		let observer = new IntersectionObserver(handler, options);
		observer.observe(observable);
	}

	/*****************************************************
	OBSERVER TO CHANGE SUBNAV POS
	/*****************************************************/

	if(document.getElementById('default')){
		let observer_itemM = document.querySelector(".sub-menu");
		let observableM = document.getElementById('default').getElementsByClassName('top-content')[0];

		if (observer_itemM && observableM){
			let optionsM = {
				root: null, // relative to document viewport 
				rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				threshold:0.197 // visible amount of item shown in relation to root
			};

			// console.log(observer_item);

			function handler(entries, observer) {
				//console.log('🍺');
				let entry;
				entries.forEach(function(entry){
						if (entry.isIntersecting) {
							observer_itemM.classList.remove("scroll");
						} else {
							observer_itemM.classList.add("scroll");
						}
					});
			}

			let observerM = new IntersectionObserver(handler, optionsM);
			observerM.observe(observableM);
		}
	}


	/******************************************************/

	/*****************************************************
			OBSERVER TO ADD PARALLAX EFFECT
	/*****************************************************/
	var scrollParallax = []
	var scrolled = 0

	// screen height
	var v_height = window.innerHeight
	|| document.documentElement.clientHeight
	|| document.body.clientHeight; 

	function doParallax(elm){

	    let boundes = elm.dataset.parallax.split(",") // get it from html
		//get distance in positive value
		let distance = Math.abs(boundes[0] - boundes[1])
	    if(boundes[0] > boundes[1]){
	    	//get distance in negative value (to do the scroll inversed)
	    	distance = distance * -1
	    }
	    //Equivalent distance using screen height + element height
	    const unit_scroll = distance / (v_height + elm.offsetHeight)
	    let temp = 0

	    let topElement = 0;
	    let element = elm;

	    let id_elem = elm.dataset.parallaxid

	    do {
		    topElement += element.offsetTop || 0;
		    element = element.offsetParent;
		} while (element)
	  
	    let parallaxFunction = function(){
	        //Obtain the distance between top screen and document top 0
	        scrolled = document.documentElement.scrollTop || window.pageYOffset
            //Distance of bottom page to top of the element
	    	let relative_distance = scrolled + v_height - topElement
	    	//transpoling data to move the parallax element relative to the scroll of all the screen
            temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
            //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
            elm.setAttribute('style','transform: translate(0, '+temp+'px)' ) 
		}

		scrollParallax[id_elem] = parallaxFunction

		window.addEventListener('scroll', scrollParallax[id_elem])	
	
	}

	let observers_parallax = document.querySelectorAll(".js-parallax-element")
 	console.dir(observers_parallax);
	if (observers_parallax){
		let options_parallax = {
			root: null, // relative to document viewport 
			rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: 0 // visible amount of item shown in relation to root
		}

		function handler_parallax(entries, observer) {
			let entry;
			entries.forEach(function(entry){
				if (entry.isIntersecting) {
					doParallax(entry.target)
				} else {
					let id_elem = entry.target.dataset.parallaxid
					window.removeEventListener('scroll', scrollParallax[id_elem])
				}
			})
		}

		let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)	;
		let counter = 1;
		console.dir(observers_parallax);
		observers_parallax.forEach(function(element) {
  			observable_parallax.observe(element)
  			element.dataset.parallaxid = counter
  			counter++
		})
	}
	/********************************************************************************
							END OF OBSERVER TO ADD PARALLAX EFFECT
	***********************************************************************************/


	/*****************************************************
			GET WEATHER INFO FROM API
	/*****************************************************/

	let weather_container = document.getElementById('weather-container');
	let weather_icon = document.getElementById('js-weather-icon');
	let weather_grades = document.getElementById('js-weather-grades');
	if(weather_container){
		//console.log('weather call');
		fetch('https://api.openweathermap.org/data/2.5/weather?q=Miami&appid=9ef3823236c10702846b2995b7fd6b7e&units=imperial')
		  .then(function(response) {
		    return response.json();
		  })
		  .then(function(myJson) {
		  	weather_icon.innerHTML = '<img src="https://openweathermap.org/img/w/'+myJson.weather[0].icon+'.png" alt="weather icon">';
		  	weather_grades.innerHTML = '<p>'+parseInt(myJson.main.temp)+'°F</p>';
		    // console.log(JSON.stringify(myJson.main.temp));
		    // console.log(JSON.stringify(myJson.weather[0].icon));
		    // console.log('http://openweathermap.org/img/w/'+myJson.weather[0].icon+'.png');
		  });
	}

	/********************************************************************************
							END OF GET WEATHER INFO FROM API
	***********************************************************************************/

	/***********************************************************************
						ADD ADA MAP LINK TO MAP PAGE
	/***********************************************************************/

	function addAdaMapLink ( class_name = '', label = 'View ADA MAP', href = '/ada-map', container= 'myMap') {

		let container_map = document.getElementById(container);
		let view_ada_map = document.createElement( 'div' );
		let previous_page = document.createElement( 'div' );

		view_ada_map.setAttribute('class', 'btn-ada-map');
		view_ada_map.innerHTML = '<a class="btn '+class_name+'" href="'+href+'">'+label+'</a>';

		previous_page.setAttribute('class', 'btn-previous');
		previous_page.innerHTML = '<a class="btn '+class_name+'" href="#" onclick="goBack()">Previous Page</a>';

		if(container_map){
			setTimeout(function(){ 
				container_map.appendChild(view_ada_map); 
				container_map.appendChild(previous_page);
			}, 1000);
		}
	}

	addAdaMapLink('inline-link','View list of ATTRACTIONS & ENTERTAINMENT');


	//gallery header
	if(document.getElementById('gallery') || document.getElementById('gallery-category') || document.getElementById('map-category')){
		document.getElementById('header').classList.add('alwaysscroll');
	}

	/***********************************************************************
						END OF ADD ADA MAP LINK TO MAP PAGE
	/***********************************************************************/

	$(document).ready(function () {

			/***********************************************************************
						READ MORE TERMS
			/***********************************************************************/
			$("html").on("click", '.term_btn', function(){
				if($(this).siblings('.term-text').is(':hidden')){
					$(this).siblings('.term-text').slideDown('600');
					$(this).text('close');
				}else{
					$(this).siblings('.term-text').slideUp('600');
					$(this).text('Terms & Conditions')
				}
			});		

			


		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

	

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		if(document.getElementById('play-icon')){
			let playVideo = document.getElementById('play-icon');
			let video = document.getElementById('hero-video');
			playVideo.addEventListener('click', function(){
				if(video.muted == true){
					video.muted = false;
					playVideo.src = "../assets/svg/icon-volume.svg";
				}
				else{
					video.muted = true;
					playVideo.src = "../assets/svg/icon-volume-off.svg";
				}
			})
		}
		

		//booking open and close
		let open_book = document.getElementById('js-open-booknow');
		let booking_container = document.getElementById('js-booking-container');
		let close_booking = document.getElementById('js-close-booking');
		if(open_book){
			open_book.addEventListener('click', function(event){
				event.preventDefault();
				if(booking_container){
					booking_container.classList.add('active');
				}
			})
		}
		if(close_booking){
			close_booking.addEventListener('click', function(event){
				event.preventDefault();
				if(booking_container){
					booking_container.classList.remove('active');
				}
			})
		}

		//Search if exist an ul inside another ul to do the accordion function
		if(document.getElementsByClassName('sitemap').length < 1){
			let copy_container = document.querySelector('.full-copy-container');
			if (copy_container){
				let lists = copy_container.querySelectorAll('ul ul');
				lists.forEach(function(elem){
					elem.classList.add('innerul');
					let parent = elem.parentElement;
					parent.classList.add('has-inner');
					parent.addEventListener('click',function(e){
						e.preventDefault;
						parent.classList.toggle('active');
					})
				})
			}
		}


		$(this, '.booking-content .promo').each(function(){
			$(this).find('.promo-trigger').click(bookingOpen);

		});

		function bookingOpen(){
			$(this).parent(1).find('.flyout-wrapper').css('display','block');
			$(this).parent(1).find('.flyout-wrapper').removeClass("close");
			$(this).parent(1).find('.flyout-wrapper').addClass("opened");
			$(this).unbind('click');
			$(this).click(hideBoking);
		}
		function hideBoking(){
			$(this).parent(1).find('.flyout-wrapper').css('display','none');
			$(this).parent(1).find('.flyout-wrapper').removeClass("opened");
			$(this).parent(1).find('.flyout-wrapper').addClass("close");
			
			
			$(this).unbind('click');
			$(this).click(bookingOpen);
		}
	


		//Search for the blockquote in the homepage
		let blockquote = document.querySelector('.text-quad blockquote')
		if (blockquote){
			cropText(blockquote);
		}

		//Search for any title to crop exists
		let title_to_crop = document.querySelectorAll('.js-crop-title h2')
		if (title_to_crop){
			title_to_crop.forEach((item) => cropText(item))
		}

		//Tablet open and close burger menu
		let burger_menu = document.getElementById('menuToggle');
		let primary_nav = document.getElementById('primary-nav');
		if (burger_menu && primary_nav){
			burger_menu.addEventListener('click', function(e){
				primary_nav.classList.toggle('active');
			});
		}

		//Show venue item
		$(".js-view-more").click(function(){
			$(".list-item-content").removeClass("active");
			$(".close-list-item").removeClass("active");
			$(".js-view-more").removeClass("active");
			$(this).parent().siblings(".list-item-content").addClass("active");
			$(this).addClass("active");
			$(this).siblings(".close-list-item").addClass("active");
		});

		//hide venue item
		$(".close-list-item").click(function(){
			$(".list-item-content").removeClass("active");
			$(this).removeClass("active");
			$(this).siblings(".js-view-more").removeClass("active");
		});
		

		//Add more padding if submenu exists in this page
		let sub_menu = document.querySelector('.sub-menu');
		//console.log('sub-menu')
		//console.dir(sub_menu);
		if(sub_menu){
			document.querySelector('.content.inset-container').classList.add('with-submenu');
		}

		// $('#adults').on('change', function() {
		// 	var num = +$("#adults").val() + 1;
		// 	$('#child').val(num);
		// 	//$('#child').val(this.value);
		// 	// forma más larga
		// 	//$('.otros_select').val(this.value).prop('selected', true);
		//   })


		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
	
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "mm-dd-yy";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
			minDate: new Date(2020, 9 - 1, 1),
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			altField: "#check-in-alt", 
		   	altFormat: "yy/mm/dd",
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				
				newDate.setDate(newDate.getDate() + 3);
			//	$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: "mm-dd-yy",
            changeMonth: true,
			numberOfMonths: 1,
			altField: "#check-out-alt", 
		   	altFormat: "yy/mm/dd",
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
		
	
			

		
	});

}());